type SerialPort = {
  readable?: ReadableStream<Uint8Array>;
  writable: WritableStream<Uint8Array>;
  open: (options: { baudRate: number }) => Promise<void>;
  close?: () => Promise<void>;
};

let cachedPrinterDevice: any = null; // garde le périphérique USB autorisé

declare global {
  interface Navigator {
    usb: {
      requestDevice(options: {
        filters: Array<{ vendorId?: number; productId?: number }>;
      }): Promise<any>;
      getDevices(): Promise<any[]>;
    };
  }
}

export const PrintAction = async (
  printData: Uint8Array | ArrayBuffer|[],
  openDrawer: boolean = false,
  ticket: boolean = true
) => {
  try {
    if (!cachedPrinterDevice) {
      const devices = await navigator.usb.getDevices();
      if (devices.length === 0) {
        throw new Error(
          "Aucune imprimante autorisée. Veuillez connecter l’imprimante via le bouton."
        );
      }
      cachedPrinterDevice = devices[0];
    }

    const device = cachedPrinterDevice;
    if (!device.opened) await device.open();
    if (!device.configuration) await device.selectConfiguration(1);
    await device.claimInterface(0);

    const outEndpoint = (
      device.configuration.interfaces[0].alternates[0].endpoints as any[]
    ).find((e: any) => e.direction === "out");

    if (!outEndpoint) throw new Error("No OUT endpoint found");
    if (ticket) {
      // Convertir les données en Uint8Array si besoin
      const bytes =
        printData instanceof Uint8Array ? printData : new Uint8Array(printData);

      // 1️⃣ Envoyer l'impression
      await device.transferOut(outEndpoint.endpointNumber, bytes);
    }

    // 2️⃣ Envoyer le kick drawer si demandé
    if (openDrawer) {
      const drawerCmd = new Uint8Array([0x1b, 0x70, 0x00, 0x19, 0xfa]);
      await device.transferOut(outEndpoint.endpointNumber, drawerCmd);
    } else {
      console.log("no Tiroire");
    }

    return true;
  } catch (err: any) {
    console.error("Erreur lors de l’impression :", err);
    return false;
  }
};
